import { Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { UserDictionary, UserModel } from '../../models';
import { AbstractConfigurationProvider } from '../../services/api';
import { normalizeSpaces } from '../../utils';
import { UsersUpdatedAction } from '../actions';

@Injectable()
export class UserEffects {
  constructor(private configProvider: AbstractConfigurationProvider) {}

  loadUsers$ = createEffect(() =>
    this.configProvider.getAllUsers().pipe(
      map((users) =>
        UsersUpdatedAction({
          userDictionary: this.createUsersDictionary(users),
        }),
      ),
    ),
  );

  private createUsersDictionary(users: UserModel[]): UserDictionary {
    if (!users) {
      return {};
    }

    return users
      .map((user) => ({
        ...user,
        name: normalizeSpaces(user.name).trim(),
      }))
      .reduce(
        (result, user) => ({
          ...result,
          [user.name]: user,
        }),
        {} as UserDictionary,
      );
  }
}
